import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'
import type { TypeComponentCtaLinkSkeleton } from './TypeComponentCtaLink'
import type { TypeHeaderDropdownMenuSkeleton } from './TypeHeaderDropdownMenu'
import type { TypeHeaderRichMenuSkeleton } from './TypeHeaderRichMenu'

export interface TypeHeaderLinkGroupFields {
  internalName: EntryFieldTypes.Symbol
  links?: EntryFieldTypes.Array<
    EntryFieldTypes.EntryLink<
      TypeComponentCtaLinkSkeleton | TypeHeaderDropdownMenuSkeleton | TypeHeaderRichMenuSkeleton
    >
  >
}

export type TypeHeaderLinkGroupSkeleton = EntrySkeletonType<TypeHeaderLinkGroupFields, 'headerLinkGroup'>
export type TypeHeaderLinkGroup<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeHeaderLinkGroupSkeleton,
  Modifiers,
  Locales
>

export function isTypeHeaderLinkGroup<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry?: Entry<EntrySkeletonType, Modifiers, Locales> | undefined
): entry is TypeHeaderLinkGroup<Modifiers, Locales> {
  return entry?.sys?.contentType?.sys?.id === 'headerLinkGroup'
}
